import Vue from 'vue'
import Router from 'vue-router'
import Form from './views/Form/index.vue'
import Error404 from './views/Error/index.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'error',
      component: Error404
    },
    {
      path: '/:hash',
      name: 'form',
      component: Form
    },
    {
      path: '*',
      redirect: {
        name: 'error'
      }
    }
  ]
})

export default router
